import { frontendURL } from '../../../../helper/URLHelper';

const helpcenter = accountId => ({
  parentNav: 'helpcenter',
  routes: [
    'portals_index',
    'portals_articles_index',
    'portals_articles_new',
    'portals_articles_edit',
    'portals_categories_index',
    'portals_categories_articles_index',
    'portals_categories_articles_edit',
    'portals_locales_index',
    'portals_settings_index',
  ],
  menuItems: [
    {
      icon: 'book',
      label: 'HELP_CENTER.ARTICLES',
      toState: frontendURL(`accounts/${accountId}/portals/portals_articles_index`),
      toStateName: 'portals_articles_index',
    },
    {
      icon: 'folder',
      label: 'HELP_CENTER.CATEGORIES',
      toState: frontendURL(`accounts/${accountId}/portals/portals_categories_index`),
      toStateName: 'portals_categories_index',
    },
    {
      icon: 'languages',
      label: 'HELP_CENTER.LOCALES',
      toState: frontendURL(`accounts/${accountId}/portals/portals_locales_index`),
      toStateName: 'portals_locales_index',
    },
    {
      icon: 'settings',
      label: 'HELP_CENTER.SETTINGS',
      toState: frontendURL(`accounts/${accountId}/portals/portals_settings_index`),
      toStateName: 'portals_settings_index',
    },
  ],
});

export default helpcenter;
